import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from "react-router-dom";
import { getDepartmentLastChild } from '../../config';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { setPageHeadObject } from '../actions/app';

const PageHead = ({ pageHead, listCount, setPageHeadObject }) => {
  let location = useLocation();
  let { lang } = useParams();

  useEffect(() => {
    const params = location.pathname.split('/').filter(i => ![lang, 'my', ''].includes(i));
    let head = getDepartmentLastChild(params);
    setPageHeadObject(head);
  }, []);

  if (pageHead){
    return <h1>
      { pageHead.title }{ listCount > 0 && <span> ({listCount})</span> }
      { pageHead.create &&
        <Link className='cabinet-create-link my-3 my-md-0' to='create/'>
          <i className='icon icon-plus'></i> { gettext('Добавить') }
        </Link>
       }
      </h1>
  }
  return <></> ;
};

PageHead.defaultProps = {
  listCount: 0
};

PageHead.propTypes = {
  pageHead: PropTypes.shape({
    title: PropTypes.string.isRequired,
    create: PropTypes.bool,
    children: PropTypes.object
  }),
  setPageHeadObject: PropTypes.func.isRequired,
  listCount: PropTypes.number
}

let mapStateToProps = (state) => {
  return {
    pageHead: state.app.pageHead,
  }
};

export default compose(
  connect(mapStateToProps, { setPageHeadObject }),
)(PageHead);


